
<div class="image-gen-ai">
  <div class="image-gen-ai__header">
    <h2>AI Image Generator</h2>
    <p>Enter a prompt to generate an image using AI</p>
  </div>

  <div class="image-gen-ai__form">
    <cvt-input
      placeholder="Describe the image you want to generate..."
      type="textarea"
      label="Image Prompt"
      rows="4"
      class="image-gen-ai__textarea"
      :disabled="isGenerating"
      @input="onPromptChange"
    />

    <cvt-button
      :disabled="!canGenerate"
      :loading="isGenerating"
      class="image-gen-ai__generate-btn"
      color="primary"
      :text="isGenerating ? 'Please wait...' : 'Generate'"
      @click="generateImage"
    />
  </div>

  <div v-if="isGenerating || generatedImage" class="image-gen-ai__preview">
    <h3 v-if="generatedImage && generatedImage.url && !isGenerating">{{ isGenerating ? 'Generating Image' : 'Generated Image' }}</h3>

    <!-- Loading State -->
    <div v-if="isGenerating" class="image-gen-ai__loading">
      <cvt-loading-message message="Generating your image" :display="true" />
      <div class="image-gen-ai__loading-placeholder">
        <div class="image-gen-ai__spinner"></div>
      </div>
    </div>

    <!-- Generated Image -->
    <div
      v-else-if="generatedImage"
      class="image-gen-ai__image-container"
      @mouseenter="showUseButton = true"
      @mouseleave="showUseButton = false"
    >
      <img
        :src="generatedImage && generatedImage.url"
        :alt="generatedImage && generatedImage.prompt"
        class="image-gen-ai__image"
      />
      <div v-if="showUseButton" class="image-gen-ai__overlay">
        <cvt-button
          class="image-gen-ai__use-btn"
          color="success"
          text="Use Image"
          @click="useImage"
        >
        </cvt-button>
      </div>
    </div>
  </div>

  <div v-if="error" class="image-gen-ai__error">
    <p>{{ error }}</p>
  </div>
</div>
